
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 20.9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9zM17.1 23c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9zM20.7 24.9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9zM44.4 22.2c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.6 34.7c.7-.7 1.2-1.7 1.2-2.8 0-1.9-1.4-3.5-3.2-3.8h-.1v-1.6c0-6.9-5.6-12.5-12.4-12.5H21.2c-6.9 0-12.4 5.6-12.4 12.4V28c-.3.1-.5.2-.6.4-1.3.7-2.1 2-2.1 3.5-.1 1.1.4 2.1 1.1 2.8-.7.7-1.2 1.7-1.2 2.8 0 1.8 1.2 3.3 2.8 3.7.5 3.2 3.2 5.6 6.5 5.6H44c3.2 0 5.9-2.4 6.4-5.5 1.9-.3 3.4-1.9 3.4-3.9 0-1-.5-2-1.2-2.7zm-2.7-1.1h-2.3l3-3.2c.6.3 1 .9 1 1.5 0 .9-.8 1.7-1.7 1.7zm-38.3-3.4H27l-7.7 8.4-7.7-8.4zm18 .5l2.6 2.8H27l2.6-2.8zM25 35.8h9.3l3.1 3.4H21.8l3.2-3.4zm7.2-5.6h15.4l-7.7 8.4-7.7-8.4zm-11-14h16.9c5.6 0 10.2 4.6 10.2 10.2V28H11v-1.5c0-5.7 4.6-10.3 10.2-10.3zm-13 15.7c0-.5.3-1 .6-1.3l2.8 3H9.9c-.9 0-1.7-.8-1.7-1.7zm0 5.6c0-.9.8-1.7 1.7-1.7h3.8l3.1 3.4H9.9c-.9 0-1.7-.8-1.7-1.7zM44 44.6H15.3c-2 0-3.7-1.4-4.2-3.2h37c-.5 1.8-2.1 3.2-4.1 3.2zm5.9-5.4h-7.4l3.1-3.4h4.3c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7z"}})])
          )
        }
      }
    